var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1514,
    height: 2239,
    viewBox: "0 0 1514 2239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1L1.00003 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 1L73 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 1L145 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 1L217 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 1L289 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 1L361 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 1L433 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 1L505 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 1L577 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 1L649 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721 1L721 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 1L793 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 1L865 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 1L937 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009 1L1009 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081 1L1081 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153 1L1153 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1L1225 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 1L1297 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369 1L1369 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441 1L1441 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513 1L1513 1081",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 865L1513 865",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 937L1513 937",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1010L1513 1010",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1083L1513 1083",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 793L1513 793",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 721L1513 721",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 649L1513 649",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 577L1513 577",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 505L1513 505",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 433L1513 433",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 361L1513 361",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 289L1513 289",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 217L1513 217",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 145L1513 145",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 73L1513 73",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1L1513 0.999976",
    stroke: "black",
    strokeOpacity: 0.06
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1083L1.00003 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 1083L73 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 1083L145 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217 1083L217 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 1083L289 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 1083L361 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 1083L433 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505 1083L505 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577 1083L577 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 1083L649 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721 1083L721 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 1083L793 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865 1083L865 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M937 1083L937 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009 1083L1009 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081 1083L1081 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153 1083L1153 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225 1083L1225 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1297 1083L1297 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1369 1083L1369 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441 1083L1441 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513 1083L1513 2163",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1947L1513 1947",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2019L1513 2019",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2092L1513 2092",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2165L1513 2165",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 2238L1513 2238",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1875L1513 1875",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1803L1513 1803",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1731L1513 1731",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1659L1513 1659",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1587L1513 1587",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1515L1513 1515",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1443L1513 1443",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1371L1513 1371",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1299L1513 1299",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1227L1513 1227",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1155L1513 1155",
    stroke: "black",
    strokeOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1083L1513 1083",
    stroke: "black",
    strokeOpacity: 0.06
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.aee37af9e4417570dd974db75d4d0ce5.svg";
export { ForwardRef as ReactComponent };